import { FileValue } from "./file-param.js";
import { FilesValue } from "./files-param.js";
export default class Result {
    constructor(dto) {
        this.dto = dto;
    }
    get duration() {
        return this.dto.ConversionCost;
    }
    get files() {
        return this.dto.Files;
    }
    toParamFile(idx = 0) {
        return new FileValue(this.dto.Files[idx].FileName, this.dto.Files[idx].FileId);
    }
    toParamFiles() {
        return new FilesValue(this.dto.Files);
    }
    uploadToS3(region, bucket, accessKeyId, secretAccessKey) {
        return this.dto.Files.map(f => {
            let dto = {
                region: region,
                bucket: bucket,
                accessKeyId: accessKeyId,
                secretAccessKey: secretAccessKey,
                fileId: f.FileId
            };
            return fetch(`https://integration.convertapi.com/s3/upload`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(dto)
            });
        });
    }
}
//# sourceMappingURL=result.js.map